import React, { useState, useEffect } from 'react';
import { Button, Backdrop, CircularProgress } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useSnackbar } from 'notistack';

import Api from '../../../Api';
import Modal from '../../../components/Modal/Modal';
import FolderTreeSelect from './FolderTreeSelect';

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    maxHeight: 'calc(100vh - 200px) !important'
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    color: '#fff'
  }
}));

// allFolders: flat list (managers). folder: the folder being moved.
const MoveFolderModal = ({ handleClose, visibility, folder, allFolders }) => {
  const { enqueueSnackbar } = useSnackbar();
  const styles = useStyles();

  const [destination, setDestination] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDestination(null);
  }, [visibility, folder]);

  // Exclude the folder itself AND its entire descendant subtree so the UI can
  // never offer a move that would create a cycle (the server enforces this too).
  const buildExcludedIds = () => {
    const ids = new Set();
    if (!folder) return ids;
    ids.add(Number(folder.id));
    const all = allFolders || [];
    let changed = true;
    while (changed) {
      changed = false;
      all.forEach(f => {
        const parentId = f.parent_id == null ? null : Number(f.parent_id);
        if (parentId != null && ids.has(parentId) && !ids.has(Number(f.id))) {
          ids.add(Number(f.id));
          changed = true;
        }
      });
    }
    return ids;
  };

  const excludedIds = buildExcludedIds();

  const handleCloseDismiss = () => {
    handleClose();
  };

  const handleSubmit = event => {
    event.preventDefault();
    if (destination === null) return;
    setLoading(true);

    Api.put('/drive_folders/' + folder.id, { parent_id: destination.id })
      .then(function() {
        setLoading(false);
        enqueueSnackbar('Carpeta movida exitosamente!', {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'success'
        });
        handleClose(true);
      })
      .catch(function(error) {
        setLoading(false);
        var message = 'Error de conexion, contacta a soporte';
        if (error.response) {
          message = 'Ocurrio un error, intenta nuevamente.';
        }
        enqueueSnackbar(message, {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          variant: 'error'
        });
      });
  };

  return (
    <div>
      <Modal handleClose={handleCloseDismiss} visibility={visibility} title={'Mover ' + (folder ? folder.name : '')} maxWidth="sm">
        <form onSubmit={handleSubmit}>
          <DialogContent dividers>
            <FolderTreeSelect
              folders={allFolders}
              selectedId={destination ? destination.id : undefined}
              onSelect={setDestination}
              excludeIds={excludedIds}
              includeRoot
            />
          </DialogContent>
          <DialogActions>
            <Button disabled={destination === null} type="submit" color="primary">
              {destination ? 'Mover a "' + destination.name + '"' : 'Mover'}
            </Button>
          </DialogActions>
        </form>
      </Modal>
      <Backdrop className={styles.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default MoveFolderModal;
